/**
 * Типы и константы экшенов слайса профиля.
 *
 * @module store/profile/actionTypes
 */

import type { SurveyUserProfile } from './userProfile.types';

/** Старт загрузки профиля */
export const FETCH_PROFILE_START = 'FETCH_PROFILE_START';
/** Успешная загрузка профиля */
export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
/** Ошибка загрузки профиля */
export const FETCH_PROFILE_ERROR = 'FETCH_PROFILE_ERROR';

/** Ключ ошибки загрузки в meta.errors */
export const PROFILE_FETCH_ERROR_KEY = 'fetch';

export type FetchProfileStartAction = {
  type: typeof FETCH_PROFILE_START;
  payload: { token: string };
};

export type FetchProfileSuccessAction = {
  type: typeof FETCH_PROFILE_SUCCESS;
  payload: SurveyUserProfile;
};

export type FetchProfileErrorAction = {
  type: typeof FETCH_PROFILE_ERROR;
  payload: Record<string, unknown>;
};

export const SET_PROFILE_FULFILL = 'SET_PROFILE_FULFILL';

export type SetProfileFulfillAction = {
  type: typeof SET_PROFILE_FULFILL;
  payload: boolean | null;
};

export type ProfileAction =
  | FetchProfileStartAction
  | FetchProfileSuccessAction
  | FetchProfileErrorAction
  | SetProfileFulfillAction;
